import { isNavGroup, isNavSection, NavGroup, NavLeaf, NavNode } from "./navigation.types"

export interface FlattenedLeaf extends NavLeaf {
  parentId: string | null
}

const flattenChild = (child: NavLeaf | NavGroup, leaves: FlattenedLeaf[]): void => {
  if (isNavGroup(child)) {
    for (const grandchild of child.children) {
      leaves.push({ ...grandchild, parentId: child.id })
    }
    return
  }
  leaves.push({ ...child, parentId: null })
}

export function flattenLeaves(nodes: NavNode[]): FlattenedLeaf[] {
  const leaves: FlattenedLeaf[] = []

  for (const node of nodes) {
    if (isNavSection(node)) {
      for (const child of node.children) flattenChild(child, leaves)
      continue
    }
    if (isNavGroup(node)) {
      for (const child of node.children) {
        leaves.push({ ...child, parentId: node.id })
      }
      continue
    }
    leaves.push({ ...node, parentId: null })
  }

  return leaves
}
